var YTIMES = YTIMES || {};
YTIMES.trophycentral = YTIMES.trophycentral || {};
YTIMES.trophycentral.crossSells = YTIMES.trophycentral.crossSells || {};

YTIMES.trophycentral.LOGGING = true;

YTIMES.trophycentral.crossSells.get = function () {
    const LOGGING = YTIMES.trophycentral.LOGGING;
    const MIN_PRODUCTS = 6;
    const MAX_SIBLINGS_PERCENT = .2;
    const MAX_TOTAL_SIBLINGS = 4;
    const MAX_ADDITIONAL_CROSSSELLS = 2;
    const MAX_CROSSSELLS_PERCENT = .5;
    const MAX_TOTAL_PRODUCTS = 6;

    // get product id from url: https://www.trophycentral.com/9x7cherryh.html
    const url = new URL(window.location.href);
    if ($("input[name='vwitem']").length != 0) {
        productId = $("input[name='vwitem']").val();
    } else if ($("input[name='vwitem0']").length != 0) {
        productId = $("input[name='vwitem0']").val();
    } else {
        productId = pdProductId || null;
    }
    if (!productId) {
        if (LOGGING) {
            console.warn('No product ID found');
        }
        return;
    }

    if ($("#breadcrumbs .breadcrumbs:visible:first a").length < 2) {
        // no parent category found
        if (LOGGING) {
            console.warn('No parent category found');
        }
        return;
    }

    const parentId = $("#breadcrumbs .breadcrumbs:visible:first a:last").attr("href").split('.')[0];

    fetch('https://www.ytimes.net/store-folders/trophycentral/cross-sells/index.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: productId,
            parent: parentId
        })
    })
        .then(response => response.json())
        .then(data => {
            if (LOGGING) {
                console.log('Product ID:', productId);
                console.log('Parent ID:', parentId);
                console.log(data);
            }

            const siblingsCount = data.siblings ? data.siblings.length : 0;
            const crossSellCount = data.crossSellProducts ? data.crossSellProducts.length : 0;

            if ((siblingsCount < MIN_PRODUCTS || !data.siblings) &&
                (crossSellCount < MIN_PRODUCTS || !data.crossSellProducts)) {
                if (LOGGING) {
                    console.log('Not enough products found - Siblings:', siblingsCount, 'CrossSells:', crossSellCount);
                }
                return;
            }

            // Sort siblings by base-price (ascending)
            if (data.siblings && data.siblings.length > 0) {
                data.siblings.sort((a, b) => a['base-price'] - b['base-price']);
            }

            // Sort crossSellProducts by base-price (ascending)
            if (data.crossSellProducts && data.crossSellProducts.length > 0) {
                data.crossSellProducts.sort((a, b) => a['base-price'] - b['base-price']);
            }

            selectedProducts = [];

            if (siblingsCount > MIN_PRODUCTS) {
                const maxSiblingsToSelect = Math.min(MAX_TOTAL_SIBLINGS, Math.floor(data.siblings.length * MAX_SIBLINGS_PERCENT));
                const siblingsPercentage = maxSiblingsToSelect / data.siblings.length;

                const selectedSiblings = YTIMES.trophycentral.crossSells.selectProductsAroundTarget(
                    data.siblings,
                    productId,
                    siblingsPercentage
                );

                selectedProducts = selectedProducts.concat(selectedSiblings);

                if (data.crossSellProducts && data.crossSellProducts.length > 0) {
                    const crossSellPercentage = Math.min(
                        MAX_CROSSSELLS_PERCENT,
                        MAX_ADDITIONAL_CROSSSELLS / data.crossSellProducts.length
                    );

                    const additionalCrossSells = YTIMES.trophycentral.crossSells.selectProductsAroundTarget(
                        data.crossSellProducts,
                        productId,
                        crossSellPercentage
                    );

                    selectedProducts = selectedProducts.concat(additionalCrossSells);
                }
            } else if (data.crossSellProducts && data.crossSellProducts.length > MIN_PRODUCTS) {
                if (LOGGING) {
                    console.log('Selecting from cross-sell products only');
                }
                const maxCrossSellsToSelect = Math.min(MAX_TOTAL_PRODUCTS, Math.floor(data.crossSellProducts.length * MAX_CROSSSELLS_PERCENT));
                const crossSellPercentage = maxCrossSellsToSelect / data.crossSellProducts.length;

                const selectedCrossSells = YTIMES.trophycentral.crossSells.selectProductsAroundTarget(
                    data.crossSellProducts,
                    productId,
                    crossSellPercentage
                );

                selectedProducts = selectedProducts.concat(selectedCrossSells);
            }

            if (selectedProducts.length === 0) {
                if (LOGGING) {
                    console.log('No products selected after filtering');
                }
                return;
            }

            // Limit total products to MAX_TOTAL_PRODUCTS
            if (selectedProducts.length > MAX_TOTAL_PRODUCTS) {
                selectedProducts = selectedProducts.slice(0, MAX_TOTAL_PRODUCTS);
            }

            // Extract first number from price fields
            // selectedProducts.forEach(product => {
            //     if (product.price && typeof product.price === 'string') {
            //         product.price = product.price.split(' ')[0];
            //     }
            //     if (product['sale-price'] && typeof product['sale-price'] === 'string') {
            //         product['sale-price'] = product['sale-price'].split(' ')[0];
            //     }
            // });

            if (selectedProducts.length === 0) {
                if (LOGGING) {
                    console.log('No products selected after filtering');
                }
                return;
            }

            if (LOGGING) {
                console.log('Selected Products:', selectedProducts);
            }
            YTIMES.trophycentral.crossSells.show(selectedProducts);
        })
        .catch(error => {
            console.error('CrossSells Error:', error);
        });
};

/**
 * Selects a percentage of products from an array, distributed around a target product
 * @param {Array} products - Array of products sorted by price
 * @param {string} targetProductId - ID of the product to center selection around
 * @param {number} percentage - Percentage of products to select (0.0 to 1.0)
 * @returns {Array} Selected products (excluding the target product)
 */
YTIMES.trophycentral.crossSells.selectProductsAroundTarget = function (products, targetProductId, percentage) {
    const LOGGING = YTIMES.trophycentral.LOGGING;

    if (!products || products.length === 0) return [];

    const maxToSelect = Math.max(2, Math.floor(products.length * percentage));
    if (maxToSelect === 0) return [];

    if (LOGGING) {
        console.group('📦 Cross-Sells Processing');
        console.log(`Selecting products around target ID: ${targetProductId}`);
        console.log('Products:', products.map(p => p.id));
        console.log(`percentage: ${percentage}, maxToSelect: ${maxToSelect}`);
    }

    const currentProductIndex = products.findIndex(product => product.id === targetProductId);

    // If target product not found, select from beginning
    if (currentProductIndex === -1) {
        if (LOGGING) {
            console.log(`Target product not found, selecting from beginning`);
        }
        return products.slice(0, maxToSelect);
    }

    const halfSelection = Math.max(1, Math.floor(maxToSelect / 2));
    if (LOGGING) {
        console.log(`currentProductIndex: ${currentProductIndex}, halfSelection: ${halfSelection}`);
    }

    let startIndex = Math.max(0, currentProductIndex - halfSelection);
    let endIndex = Math.min(products.length - 1, currentProductIndex + halfSelection);

    // If we can't get enough products before the current product, extend forward
    if (currentProductIndex - halfSelection < 0) {
        const shortage = halfSelection - currentProductIndex;
        endIndex = Math.min(products.length - 1, endIndex + shortage);
    }

    // If we can't get enough products after the current product, extend backward
    if (currentProductIndex + halfSelection >= products.length) {
        const shortage = (currentProductIndex + halfSelection) - (products.length - 1);
        startIndex = Math.max(0, startIndex - shortage);
    }
    if (LOGGING) {
        console.log(`Initial startIndex: ${startIndex}, endIndex: ${endIndex}`);
    }

    // Select the products (excluding the target product)
    let selectedProducts = products.slice(startIndex, endIndex + 1)
        .filter(product => product.id !== targetProductId);

    // If we still don't have enough after filtering, extend the selection
    while (selectedProducts.length < maxToSelect && (startIndex > 0 || endIndex < products.length - 1)) {
        if (startIndex > 0) {
            startIndex--;
        }
        if (endIndex < products.length - 1 && selectedProducts.length < maxToSelect) {
            endIndex++;
        }
        selectedProducts = products.slice(startIndex, endIndex + 1)
            .filter(product => product.id !== targetProductId);
    }
    if (LOGGING) {
        console.groupEnd();
    }
    // Trim to exact count if we went over
    return selectedProducts.slice(0, maxToSelect);
};

YTIMES.trophycentral.crossSells.show = function (selectedProducts) {
    const LOGGING = YTIMES.trophycentral.LOGGING;

    if (!selectedProducts || selectedProducts.length === 0) {
        return;
    }

    $("#related2015.ytimesDynamicCrossSells").append("<h5>Related <b>Products</b></h5>");

    let container = $("<div class='sections table-js-height-'></div>");

    selectedProducts.forEach(product => {
        let url = product.id + ".html";
        let imageUrl = 'https://s.turbifycdn.com/aah/sportsawards/' + product.image;
        let name = product.name;
        let pdRating = Math.ceil(product['pd-rating']);
        let pdRatingCount = product['pd-rating-count'];
        let pdRatingClass = getRatingClassName(product['pd-rating']);
        let pdRatingTag = `<div class='pdRatingStarsWrapper pdCategory'></div>`;
        if (pdRating && pdRating != '' && pdRating > 0) {
            pdRatingTag =   `<div class='pdRatingStarsWrapper pdCategory'>
                                <div class='pdRatingStars ${pdRatingClass}' productid='${product.id}'>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <div class='pdRatingCount'>
                                    ${pdRatingCount}
                                    <span class='pdRatingCountDescriptorText'>Reviews</span>
                                </div>
                            </div>`;
        };


        const isOnSale = product['sale-price'] != '' && product['price'] != '';
        let priceTag = '<span class=regPr></span>';
        if (isOnSale) {
            const pr = product['price'].split(' ')[0];
            const formattedPrice = `$${parseFloat(product.price).toFixed(2)}`;
            priceTag = `<span class=regPr>
                            ${formattedPrice}
                        </span>`;
        }
        let priceBrackets = product['sale-price'] != '' ? product['sale-price'].split(' ') : product['price'].split(' ');
        // add a 1 to the front of priceBrackets
        priceBrackets.unshift('1');
        // convert each element to float
        priceBrackets = priceBrackets.map(x => parseFloat(x));

        // Calculate lowest unit price from the last qty/total price pair
        const lastQty = priceBrackets[priceBrackets.length - 2];
        const lastTotal = priceBrackets[priceBrackets.length - 1];
        const lowestUnitPrice = lastTotal / lastQty;
        const formattedLowestUnitPrice = `$${lowestUnitPrice.toFixed(2)}`;

        const asLowAsTag = priceBrackets.length > 2 ? `As low as ${formattedLowestUnitPrice}` : `${formattedLowestUnitPrice}`;

        let itemTag = `
            <div class='item'>
                <a href='${url}' class='product-image'>
                    <img src='${imageUrl}' alt='${name}' title='${name}' loading='lazy' />
                </a>
                <div class='textBox'>
                    <div class=itemMid>
                        <div class=title>
                            <h2 style='margin:0;padding:0;font-size:15px;text-align:center;'>
                                <a href='${url}' title='${name}'>${name}</a>
                            </h2>
                        </div>
                        ${pdRatingTag}
                    </div>
                    <div class=sectPr>
                        ${priceTag}
                        ${asLowAsTag}
                    </div>
                </div>
            </div>
        `;

        container.append(itemTag);
    });

    $("#related2015.ytimesDynamicCrossSells").append(container);

    // Create table element
    // const table = document.createElement('table');
    // table.style.border = '1px solid black';
    // table.style.borderCollapse = 'collapse';
    // table.style.margin = '20px';
    // table.style.fontSize = '12px';

    // // Create header row
    // const headerRow = document.createElement('tr');
    // const headers = ['ID', 'Name', 'Price', 'Sale Price', 'Base Price'];

    // headers.forEach(headerText => {
    //     const th = document.createElement('th');
    //     th.textContent = headerText;
    //     th.style.border = '1px solid black';
    //     th.style.padding = '5px';
    //     th.style.backgroundColor = '#f0f0f0';
    //     headerRow.appendChild(th);
    // });

    // table.appendChild(headerRow);

    // // Create data rows
    // selectedProducts.forEach(product => {
    //     const row = document.createElement('tr');

    //     const fields = [
    //         product.id,
    //         product.name,
    //         product.price,
    //         product['sale-price'],
    //         product['base-price']
    //     ];

    //     fields.forEach(fieldValue => {
    //         const td = document.createElement('td');
    //         td.textContent = fieldValue || '';
    //         td.style.border = '1px solid black';
    //         td.style.padding = '5px';
    //         row.appendChild(td);
    //     });

    //     table.appendChild(row);
    // });

    // document.body.appendChild(table);

    function getRatingClassName(pdRating) {
        if (!pdRating || pdRating === '0' || pdRating === '') {
            return '';
        }
        const integer = Number(pdRating[0]);
        const decimal = Number(pdRating[2]);

        if (decimal >= 8) {
            return `pd${integer + 1}0`;
        } else if (decimal >= 3) {
            return `pd${integer}5`;
        } else {
            return `pd${integer}0`;
        }
    }

};

YTIMES.trophycentral.crossSells.get();